import React from 'react';
import axios from 'axios';
import { Spin, Empty, Badge, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import * as serverconfig from '../../serverconn';
import * as serversocketconfig from '../../serversocketconfig';
import ReconnectingWebSocket from 'reconnecting-websocket';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import PolylineMap from '../components/PolylineMap';
import ProfessionalLayout from '../../../components/ProfessionalLayout';

const CryptoJS = require("crypto-js");
const { Text } = Typography;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

// Initialize WebSocket with better error handling
let agentlocationsocket = null;
try {
  agentlocationsocket = new ReconnectingWebSocket(serversocketconfig.socketurl+'/ws/agentlocationsocket/', [], {
    connectionTimeout: 1000,
    maxRetries: 3,
    reconnectInterval: 5000
  });
} catch (error) {
  console.warn('WebSocket connection not available. Using polling fallback.');
}

let token = '';
let sacco = '';

class OnlineAgentsList extends React.Component {
  state = {
    datarequested: true,
    delivery_agents: [],
  };

  componentDidMount() {
    this.initializeAuth();
    this.loadOnlineAgents();
    this.setupWebSocket();
    this.startPolling();
  }

  componentWillUnmount() {
    if (agentlocationsocket) {
      agentlocationsocket.close();
    }
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  initializeAuth = () => {
    if (localStorage.getItem("sacco")) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem("sacco"), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    }
    
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    };
  }

  loadOnlineAgents = () => {
    this.setState({ datarequested: true });
    
    axios.get(`${serverconfig.backendserverurl}/api/delivery_agents/?is_online=true&active=true`)
      .then(res => {
        this.setState({
          delivery_agents: res.data,
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading agents:', error);
        this.setState({ datarequested: false });
      });
  }

  setupWebSocket = () => {
    if (!agentlocationsocket) return;

    agentlocationsocket.onmessage = async (e) => {
      // Refresh agent locations when updates are received
      this.loadOnlineAgents();
    };

    agentlocationsocket.onopen = () => {
      console.log('Agent location socket connected');
    };

    agentlocationsocket.onerror = (error) => {
      console.warn('WebSocket connection error. Using polling fallback.');
    };

    agentlocationsocket.onclose = () => {
      console.warn('WebSocket connection closed. Using polling fallback.');
    };
  }

  startPolling = () => {
    // Fallback polling every 30 seconds when WebSocket is not available
    this.pollingInterval = setInterval(() => {
      this.loadOnlineAgents();
    }, 30000);
  }

  render() {
    const { datarequested, delivery_agents } = this.state;

    const headerActions = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Badge 
          count={delivery_agents.length} 
          style={{ 
            backgroundColor: '#52c41a',
            color: '#fff',
            fontWeight: 'bold'
          }}
        >
          <Text strong style={{ marginRight: 8 }}>Online Agents</Text>
        </Badge>
        {datarequested && <Spin indicator={antIcon} />}
      </div>
    );

    return (
      <ProfessionalLayout
        title="Live Agent Tracking"
        subtitle="Real-time monitoring of active delivery agents"
        icon={<SportsMotorsportsIcon />}
        headerActions={headerActions}
        loading={datarequested}
      >
        {!datarequested && (
          <>
            {delivery_agents.length > 0 ? (
              <div className="professional-map-container">
                <PolylineMap initialCoordinates={delivery_agents} />
              </div>
            ) : (
              <div className="professional-empty-state">
                <Empty
                  description={
                    <div>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        No agents are currently online
                      </Text>
                      <br />
                      <Text type="secondary" style={{ fontSize: 14 }}>
                        Agents will appear here when they come online
                      </Text>
                    </div>
                  }
                  imageStyle={{ height: 80 }}
                />
              </div>
            )}
          </>
        )}
      </ProfessionalLayout>
    );
  }
}

export default OnlineAgentsList; 
